import { temporaryGiftCardDomainStore } from '../store';
export const getGiftCardDetails = () => temporaryGiftCardDomainStore.data.giftCardDetails;
